import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { phuHuynhApi } from '../../api/phuHuynhApi';
import PlaceHolder from '../place-holder';
import styles from "./PhuHuynhFamily.module.css";
const PhuHuynhFamily = ({ id }) => {
    const [phuHuynhFamilys, setPhuHuynhFamily] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const componentDidMount = useRef(false);
    const history = useHistory();
    useEffect(() => {
        componentDidMount.current = true;
        handleReloadPhuHuynhFamily();
        return () => {
            componentDidMount.current = false;
        }
    }, [id])
    const handleReloadPhuHuynhFamily = async () => {
        setIsLoading(true);
        const res = await phuHuynhApi.SelectFamily(id);
        if (componentDidMount.current) {
            setIsLoading(false)
            if (res.is_success) {
                setPhuHuynhFamily(res.data);
            }
        }
    }
    return (
        <div className={styles.container}>
            {isLoading && <PlaceHolder />}
            {phuHuynhFamilys.length > 0 &&
                <p className={styles.container_caption}>Gia đình</p>
            }
            {!isLoading && <>
                {phuHuynhFamilys.map((x, idx) => {
                    return (
                        <div className={styles.phu_huynh} key={idx}>
                            <div className={styles.caption}>
                                <div className={styles.name}>
                                    <Link to={`../phu-huynh/${x.id}`}>{x.ho_ten}
                                        <i className="fas fa-chevron-right"></i>
                                    </Link>
                                </div>
                                <span className={styles.tag}>{x.quan_he}</span>
                            </div>
                            <p className={styles.info_container}>
                                <i className="fas fa-at"></i>
                                <b>{x.email}</b>
                            </p>
                            <p className={styles.info_container}>
                                <i className="fas fa-phone"></i>
                                <b>{x.dien_thoai}</b>
                            </p>
                            {/* <p className={styles.info_container}>
                                <i className="fas fa-user"></i>
                                <Link to={`../phu-huynh/${x.id}`}>Chuyển trang {x.ho_ten}
                                    <i className="fas fa-chevron-right"></i>
                                </Link>
                            </p> */}
                        </div>
                    );
                })}
            </>}
        </div>
    );
};

export default PhuHuynhFamily;